// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~styles/colors.module.css'","NEUTRAL_GRAY_900":"#0F172A","menuButtonRoot":"styles_menuButtonRoot__9PLWl"};